// src/seo/RouteSeo.jsx
import React from 'react';
import { useLocation } from 'react-router-dom';
import Seo from './Seo';
import { organizationJsonLd, webSiteJsonLd } from './siteMeta';

/**
 * Domyślne meta dla każdej trasy - renderowane raz, w Layout.
 * Podstrony dokładają tylko dane strukturalne przez <JsonLd />.
 */
const RouteSeo = () => {
  const { pathname } = useLocation();
  return <Seo path={pathname} jsonLd={[organizationJsonLd(), webSiteJsonLd()]} />;
};

export default RouteSeo;
